export const ACTIVITY_LIST = 'activity_list'
export const NEXT_ACTIVITY = 'next_activity'
export const ACTIVITY_PROPOSAL = 'activity_proposal'
export const CHECK_OPPORTUNITY_CLOSED_OR_DROPPED = 'check_opp_closed_or_dropped'
export const VIEW_ACTIVITY = 'view_Activity'
export const NEW_ACTIVITY = 'new_Activity'
export const CANCEL_ACTIVITY = 'cancel_Activity'
export const REJECT_ACTIVITY = 'reject_Activity'
export const DISTANCE_FROM_SITE = 'distance_from_site'
export const MAINTENANCE_COST = 'maintenance_cost'
export const LEAD_GATE_TYPE = 'lead_gate_type'
export const POST_CLOSURE = 'post_closure'
export const SELECTED_TAGGED_ALONG = 'selected_tagged_along'
